import React from 'react'
import { AddressElement } from '@stripe/react-stripe-js'

import InputField from 'src/components/InputField'

const fakeAddressLabel = <span style={{ opacity: 0.1 }}>█████</span>

const Contact = ({
  i18n, session, collect_phone, donation, inputProps, show_input_labels, errors,
  canadianReceipt, giftAid, hideAddress, useAddressElement = true,
  hideDonorFields, blackbaudEnabled,
  // googleApiKey,
}) => {
  const useStripeAddressElement = donation.collectAddress && useAddressElement
  // Both neighbors label above and can't be told otherwise — Stripe's
  // AddressElement by design, Blackbaud because we ask for labelStyle 'above'
  // rather than emulate their floating fields. Ours would read as a different
  // form standing next to either one, so they're forced on for this section
  // only; the amount field and the rest keep whatever the partner configured.
  const showInputLabels =
    show_input_labels || useStripeAddressElement || blackbaudEnabled

  return (
    <div className="widget-contact">
      {
        useStripeAddressElement
      ? hideAddress
      ? <div>
          <InputField label={fakeAddressLabel} />
          <InputField label={fakeAddressLabel} />
          <InputField label={fakeAddressLabel} />
          <InputField label={fakeAddressLabel} />
        </div>
      : <div className="mb-3">
          <AddressElement
            options={{
              mode: 'billing',
              // A Stripe bug causes the React app to crash when
              // PaymentRequestButton unmounts on the previous page
              // if autocomplete is enabled.

              // autocomplete: {
              //   mode: 'google_maps_api',
              //   apiKey: googleApiKey,
              // },
              defaultValues: {
                firstName: donation.state.firstName,
                lastName: donation.state.lastName,
                address: {
                  country: canadianReceipt?.value ? 'CA' : giftAid?.value ? 'GB' : '',
                },
              },
              display: { name: 'split' },
              fields: { phone: collect_phone ? 'always' : 'never' },
              validation: collect_phone ? { phone: { required: 'always' } } : {},
            }}
            onChange={({ value }) =>
              donation.dispatch({ type: 'setAddress', value })
            }
          />
        </div>
      : <div>
          {/* Blackbaud collects name + email in its own iframe when it's
              collecting the address, so we render neither. */}
          {!hideDonorFields &&
          <div className="row gx-2 row-first-and-last-names">
            <div className="col">
              <InputField
                {...inputProps('firstName', i18n.t('first_name'), { showInputLabels })}
                errors={errors}
                required
              />
            </div>
            <div className="col">
              <InputField
                {...inputProps('lastName', i18n.t('last_name'), { showInputLabels })}
                errors={errors}
                required
              />
            </div>
          </div>
          }
          {
            collect_phone &&
            <InputField
              {...inputProps('phone', i18n.t('phone'), { showInputLabels })}
              errors={errors}
              type="tel"
              required
            />
          }
        </div>
      }
      {
        session.collect_email && !hideDonorFields &&
        <InputField
          {...inputProps('email', i18n.t('email'), { showInputLabels })}
          errors={errors}
          type="email"
          data-plg-donor-field="email"
          required
        />
      }
    </div>
  )
}

export default Contact
